module.exports = __webpack_public_path__ + "img/int-search.10b24582.svg";